import React from "react";
import { container } from "@/utils/mobx";
import { ContextMenu } from "@/components/toolkit/ContextMenu";
import { ContextMenuOption } from "@/components/toolkit/ContextMenu/store";
import { Badge } from "@/components/toolkit/Badge";
import { SelectInputStore, SelectInputOption } from "./store";
import "./s.select_input.css";


export type { SelectInputOption };

export const SelectInput = container((props: {
    store: SelectInputStore;
    value: string | null;
    options: SelectInputOption[];
    onChange?: (value: string | null) => any;
    className?: string;
    placeholder?: string;
}) => {
    const store = props.store;
    const displayTitle = store.getTitle(store.value) || store.placeholder || "";

    return (
        <div
            className={
                "select_input" +
                (store.className ? " " + store.className : "") +
                (store.isPopupVisible ? " expanded" : "")
            }
        >
            <ContextMenu
                isVisible={store.isPopupVisible && !!(store.options && store.options.length)}
                options={store.options as ContextMenuOption[]}
                onClose={store.hidePopup}
                onSelect={store.changeValue}
            />
            <Badge
                className="select_input_wrapper"
                onClick={() => store.togglePopup()}
            >
                <span className={"select_input__value" + (!store.getTitle(store.value) && store.placeholder ? " select_input__value--placeholder" : "")}>{displayTitle}</span>
                <span className="select_input__arrow" />
            </Badge>
        </div>
    );
}, SelectInputStore);
